import React, { useState, useEffect } from 'react'
import CustomTableControl from '../controlComponent/customTableControl'
import { GetProducts } from '../../assets/interfaces/productInterface'

function ControlComponent() {
    const [IsUserAllowed] = useState(true)
    const [SelectedPrices, setSelectedPrices] = useState()

    useEffect(() => {
        // Removed GetUserPermissions since @carrier/auth-module doesn't exist
        // If you need user permissions, implement it differently
    }, [])

    useEffect(() => {
        if (!SelectedPrices) {
            GetProducts(
                null,
                null,
                (products) => {
                    setSelectedPrices({ Options: products })
                },
                '/control'
            )
        }
    }, [SelectedPrices])

    if (!SelectedPrices) return <h1>Loading...</h1>

    return (
        <div className='AppContent'>
            {IsUserAllowed ? (
                <CustomTableControl
                    SelectedPrices={SelectedPrices}
                    onSelectedVersionUpdate={(version) => setSelectedPrices(version)}
                />
            ) : (
                <h1>You are not authorized to see this content</h1>
            )}
        </div>
    )
}

export default ControlComponent
